<template>
    <div>
        <v-label class="pb-2">{{label}}</v-label>
        <v-data-table
            :headers="headers"
            :items="rows"
            :items-per-page="5"
            class="elevation-1 mt-2"
        ></v-data-table>
    </div>

</template>

<script>
    export default {
        name: "TableStatic",
        props: ['field', 'readonly', 'label'],
        data(){
            return {
                headers: [],
                rows: []
            }
        },

        created() {
            this.createData()
        },

        methods: {
            createData(){
                this.field.datos.th.forEach((header, index) => {
                    this.headers.push({text: header, value: `item_${index}`})
                })

                this.field.datos.td.forEach((header) => {
                    let itemArray = {}

                    header.forEach((item, index) => {
                        itemArray[`item_${index}`] = item
                    })

                    this.rows.push(itemArray)
                })
            }
        }
    }
</script>

<style scoped>
/**
id, nombre, descripcion, sexo, identificacion
 */
</style>